import script from "./sw-item-parts-url.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-url.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-url.vue?vue&type=style&index=0&id=7e1d8ea7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e1d8ea7"]])

export default __exports__